module.exports = __webpack_public_path__ + "images/lp-sl-m-shashank-kalanithi-1.webp";